import { Bones } from '@simplywallst/ui-core';
import { SnowflakeBone } from './styled';
import { cn } from '@simplywallst/ui-core/next';

export interface Props {
  industry: string | 'any';
  isSticky: boolean;
  hideIndustryCol?: boolean;
}

const TableRowSkeleton = ({
  industry,
  isSticky,
  hideIndustryCol = false,
}: Props) => (
  <tr className="pointer-events-none [&>td>span]:block">
    <td>
      <SnowflakeBone />
    </td>
    <td
      className={cn(
        'lg:w-x20',
        // Mobile styles
        isSticky ? 'max-lg:w-[95px]' : 'max-lg:w-[146px]',
        'max-lg:sticky max-lg:-left-px max-lg:z-1 max-lg:!bg-surface',
        'max-lg:focus-within:!bg-surface-1',
        isSticky &&
          'max-lg:border-0 max-lg:border-r max-lg:border-solid max-lg:border-soft max-lg:shadow-[2px_4px_4px_theme(colors.p.grey.180)]'
      )}
    >
      <span className="!grid gap-x0_5 truncate">
        <Bones maxWidth="90%" />
        <Bones maxWidth="50%" minHeight="12px" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="70%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="60%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="60%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="60%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="50%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="70%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="70%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="60%" />
      </span>
    </td>
    {industry === 'any' && hideIndustryCol === false && (
      <td>
        <span>
          <Bones maxWidth="70%" />
        </span>
      </td>
    )}
    <td className="w-[50px] !pr-x1_25">
      <span>
        <Bones maxWidth="70%" />
      </span>
    </td>
  </tr>
);

export default TableRowSkeleton;
